import agent from "../../../api/agent";
export const getList = (pagerInputModel) =>  agent.requests.post(`/UserRole/getList`, pagerInputModel);
export const create = (UserRole)        => agent.requests.post(`/UserRole/create`, UserRole);
export const deleteItem = (UserRole)  => agent.requests.post(`UserRole/delete`, UserRole);



